export class ApplicationSearchUDFDetail {
  udfId: string;
  stringValue: string;
  dateValue?: Date;
  doubleValue?: number;
}
